import type { FaireProductEntity } from "../../entity_types/product";

export const p_drqyk92fcx: FaireProductEntity = {
  token: "p_drqyk92fcx",
  type: "product",
  name: "Mahjong Collage Sweatshirt",
  brandToken: "b_ztfezrm7u7",
  brandName: "Poppy & Pine",
  imageUrl:
    "https://cdn.faire.com/fastly/ff417aa8f20efb92fc75edb60e68c4fd105fe5b0eb430639d2a65cebd4d0de59.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0db0e08e83476e649951855b714f43fbf400e6ffacac3957e78a4a541a144c16.png",
  ],
  priceDollars: 28,
  description:
    "Stay cozy and stylish with the Mahjong Collage Sweatshirt. Featuring a fun, eye-catching design inspired by classic mahjong tiles, this sweatshirt adds a playful twist to your casual wardrobe. \n*Now printed with vibrant ink colors on a soft style Gildan 50/50 blend unisex sweatshirt.\n\nModel wearing a large\n",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:45.021Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
